import { LayoutGrid, Rows3 } from 'lucide-react';
import type { ResultViewMode } from './types';

const OPTIONS: Array<{ value: ResultViewMode; label: string; Icon: typeof LayoutGrid }> = [
  { value: 'cards', label: 'Card view', Icon: LayoutGrid },
  { value: 'compact', label: 'Compact row view', Icon: Rows3 },
];

/** Top-bar control switching between full result cards and compact rows, so more results fit on screen at once. */
const ViewModeToggle = ({
  viewMode,
  onChange,
}: {
  viewMode: ResultViewMode;
  onChange: (value: ResultViewMode) => void;
}) => (
  <div className="flex items-center rounded-lg border border-gray-200 bg-white p-0.5 text-sm text-gray-500">
    {OPTIONS.map(({ value, label, Icon }) => (
      <button
        key={value}
        type="button"
        onClick={() => onChange(value)}
        title={label}
        aria-label={label}
        aria-pressed={viewMode === value}
        className={`flex items-center justify-center p-1.5 rounded-md transition-colors ${
          viewMode === value
            ? 'bg-emerald-50 text-emerald-700'
            : 'text-gray-400 hover:text-gray-700'
        }`}
      >
        <Icon className="w-4 h-4" />
      </button>
    ))}
  </div>
);

export default ViewModeToggle;
